import '../../../styles/forms.css.js';
import React__default from 'react';
import Tooltip from '../../Layout/Tooltip/Tooltip.js';
import Icon from '../../DataDisplay/Icon/Icon.js';
import styles from './ButtonIcon.module.css.js';

/**
 * Button component
 */
const ButtonIcon = ({ icon, hoverType = 'background', buttonType = 'button', disabled = false, size = 'medium', onClick, tooltipMessage = '', tooltipColor = 'dark', stopPropagation = true, boxSize, }) => {
    const ButtonContent = () => {
        const params = {
            iconSize: 1,
            boxSize: 36,
            /*   color: 'rgba(51,51,51,1)',
            hoverColor: 'rgba(0,0,0,1)', */
            disabledColor: 'rgba(0,0,0,0.2)',
            color: 'rgba(0,0,0,0.75)',
            hoverColor: hoverType === 'color' ? 'rgba(138,0,229,1)' : 'rgba(0,0,0,1)',
            radius: 8,
        };
        if (size === 'extra-small') {
            params.iconSize = 0.7;
            params.boxSize = boxSize ?? 20;
            params.radius = 4;
        }
        if (size === 'small') {
            params.iconSize = 0.8;
            params.boxSize = boxSize ?? 24;
            params.radius = 5;
        }
        if (size === 'large') {
            params.iconSize = 1.3;
            params.boxSize = boxSize ?? 50;
            params.radius = 12;
        }
        const handleClick = (event) => {
            if (stopPropagation)
                event.stopPropagation();
            if (onClick) {
                onClick(event);
            }
        };
        return (React__default.createElement("div", { onClick: !disabled ? event => handleClick(event) : () => { }, className: `${styles.icon} ${styles['icon' + hoverType]}`, style: { borderRadius: params.radius }, "data-disabled": disabled },
            React__default.createElement("button", { type: buttonType, style: {
                    border: 0,
                    backgroundColor: 'transparent',
                    margin: 0,
                    padding: 0,
                    width: params.boxSize,
                    height: params.boxSize,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                } },
                React__default.createElement(Icon, { color: !disabled ? params.color : params.disabledColor, hoverColor: !disabled ? params.hoverColor : params.disabledColor, icon: icon, iconSize: params.iconSize }))));
    };
    return (React__default.createElement(React__default.Fragment, null, tooltipMessage.length > 2 ? (React__default.createElement(Tooltip, { title: tooltipMessage, color: tooltipColor },
        React__default.createElement("div", { style: { display: 'inline-block', alignSelf: 'flex-start' } },
            React__default.createElement(ButtonContent, null)))) : (React__default.createElement(ButtonContent, null))));
};

export { ButtonIcon as default };
//# sourceMappingURL=ButtonIcon.js.map
